import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.RENAME_COLUMNS, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) => {
  const columns = config.renameColumns.map((rc) => rc.column);
  const duplicateColumnsMsg = Helpers.getDuplicateColumnsMessage(
    dataFrameSpec,
    columns,
    'Cannot rename the same column more than once.'
  );

  const noColumnsMsg = columns.length >= 1 ? null : 'Must rename at least one column';
  const emptyNames = config.renameColumns.filter((rc) => rc.name.length === 0).map((rc) => rc.column);
  const emptyNameMsg =
    emptyNames.length === 0
      ? null
      : `New name must be at least one character. Columns to fix: ${Helpers.getColumnsDisplayText(
          dataFrameSpec,
          emptyNames
        )}`;

  return Helpers.coalesceMessages(duplicateColumnsMsg, noColumnsMsg, emptyNameMsg);
};

export default {
  stepType: PipelineStepType.RENAME_COLUMNS,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.RENAME_COLUMNS, 0>;
